
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/privateAppsPanel/components/InstalledAppIndicator/installedAppIndicator.scss.css.virtualfile';
        module.exports = {"installedAppIndicator":"_installedAppIndicator_1eor1_1"};